var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fill-height"},[_c('froala',{ref:"editorHere",staticClass:"editor",staticStyle:{"width":"100%"},attrs:{"tag":"textarea","config":_vm.config,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }